import {Breadcrumb, Space} from 'antd';
import React, {useEffect, useImperativeHandle, useState} from 'react';
import {getFolderPath} from '@/services/folder/folder';
import {useRequest} from "@umijs/max";

export type FolderPathProps = {
    items?: any[];
    currentId?: string | null | undefined;
    onClick: (id: string) => void;
    onChange?: (val: {
        level: number;
        flag: number;
        authorities: string[];
        projectId?: string;
        centerId?: string;
    }) => void;
};

const FileNavigationBar = (props: FolderPathProps, ref: any) => {
    const {currentId, onChange} = props;
    const [breadcrumbItem, setBreadcrumbItem] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const renderFileNavigationBar = (fileOrFolderId?: string) => {
        if (!fileOrFolderId) {
            setBreadcrumbItem([]);
            onChange?.({
                level: 0,
                flag: 0,
                authorities: [],
            });
            return;
        }
        getFolderPath(fileOrFolderId).then((res: any) => {
            setBreadcrumbItem(
                res.map((it: any) => {
                    return {
                        title: it.isdir
                            ? it.cname
                            : `${it.name}.${it.fileType}`,
                        id: it.id,
                        isdir: it.isdir,
                    };
                })
            );
            onChange?.({
                level: res[res.length - 1].level,
                flag: res[res.length - 1].flag,
                authorities: res[res.length - 1].authorities || [],
                projectId: res[res.length - 1].projectId,
                centerId: res[res.length - 1].centerId ?? 0,
            });
        });
    };

    const onClick = (e: any, item: any) => {
        e.stopPropagation();
        props.onClick(item);
    };

    useEffect(() => {
        if (currentId && !loading) {
            setLoading(true);
            renderFileNavigationBar(currentId!);
            setLoading(false);
        } else {
            renderFileNavigationBar(currentId || '');
        }
    }, [currentId]);

    useImperativeHandle(ref, () => ({
        reload: () => {
            renderFileNavigationBar(currentId || '');
        },
        getCurrentBreadcrumb: () => {
            return breadcrumbItem; // 返回当前面包屑数组
        },
    }));

    return (
        <Space>
            <div>当前位置:</div>
            <Breadcrumb>
                <Breadcrumb.Item href={'javascript:void(0)'} onClick={(e) => onClick(e, null)}>
                    全部文件
                </Breadcrumb.Item>
                {breadcrumbItem?.map((item) => (
                    <Breadcrumb.Item
                        key={item.id}
                        href={'javascript:void(0)'}
                        onClick={(e) => onClick(e, item)}
                    >
                        {item.title}
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        </Space>

    );
};

export default React.forwardRef(FileNavigationBar);
